import PostRequest from 'components/common/PostRequest.jsx';

/**
 * Handles resetting the selected list for a nav section.
 * This is shared between QuoteBuilderNavSection and LayoutSvg components.
 *
 * @param {Object} options
 * @param {number} options.index - The nav section index
 * @param {Function} options.setSelectedList - State setter for selected list
 * @param {Function} [options.setSolution] - Optional state setter for solution (used in LayoutSvg)
 * @param {Function} [options.onSuccess] - Optional, run once the server has actually reset the section. Local
 *   state that must not be cleared while the server still holds the selection belongs here rather than at the
 *   call site: a caller that clears up front shows an unpriced section that the next reload contradicts.
 * @returns {Promise} the request, so a caller can react to a reset that did NOT happen.
 */
const resetSelectedListHandler = ({ index, setSelectedList, setSolution, onSuccess }) => (
  PostRequest({
    url: `/layouts-nav-section-combinations/reset-selected-list/${window.user_quote_id}/${index}`,
    data: {},
    callback: (data) => {
      setSelectedList(() => []);

      if (setSolution) {
        setSolution(() => undefined);
      }

      // Update window.user_quote_nav_sections so shouldHideSection can check updated data
      if (data.window_nav_sections) {
        window.user_quote_nav_sections = data.window_nav_sections;
      }

      // Emit event to reset linked sections and trigger re-render
      window.dispatchEvent(new CustomEvent('navSectionsReset', {
        detail: {
          resetIndices: data.reset_linked_indices || [],
          sourceIndex: index,
          windowNavSections: data.window_nav_sections
        }
      }));

      if (onSuccess) {
        onSuccess(data);
      }

      if (data.page_reload) {
        location.reload(true);
      }
    }
  })
);

export default resetSelectedListHandler;
